import React from 'react'
import axios from 'axios';
import StripeCheckout from 'react-stripe-checkout';


import {CardElement} from 'react-stripe-elements';



// import STRIPE_PUBLISHABLE from './constants/stripe';
// import PAYMENT_SERVER_URL from './constants/server';

const STRIPE_PUBLISHABLE = 'pk_live_RxPqNV8wJES88O9PlWkRbiqU';

// for localhost
const PAYMENT_SERVER_URL = '/signup';

//for google cloud
// const PAYMENT_SERVER_URL = 'https://8080-dot-3767808-dot-devshell.appspot.com/signup';


const CURRENCY = 'EUR';

const fromEuroToCent = amount => amount * 100;

const successPayment = data => {
	alert('Payment Successful');
	// console.log(data);
};

const errorPayment = data => {
	alert('Payment Error');
	// console.log(data);
};

const onToken = (amount, description) => token =>
axios.post(PAYMENT_SERVER_URL,
{
	description,
	source: token.id,
	currency: CURRENCY,
	amount: fromEuroToCent(amount)
})
.then(successPayment)
.catch(errorPayment);

const Checkout = ({ name, description, amount, label }) =>
<StripeCheckout
name={name}
description={description}
amount={fromEuroToCent(amount)}
token={onToken(amount, description)}
currency={CURRENCY}
stripeKey={STRIPE_PUBLISHABLE}
label = {label}
/>

export default Checkout;